
import React, { useState, useEffect } from "react";
import { DatePicker, Space, Typography } from 'antd';
import Swal from "sweetalert2";
import moment from 'moment';
import { API_BASE_URL, INSERT_LATE_INDENT_REQ, GET_USER_STORES } from "../../Config";
import Select from "react-select";
import Axios from 'axios';


const ApplyLateIndentReq = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [reason, setReason] = useState("");
    const [dates, setDates] = useState([]);
    const [lateReqSubLoading, setLateReqSubLoading] = useState(false);
    const { RangePicker } = DatePicker;
    const [selectedStore, setSelectedStore] = useState(null);
    const [storeData, setStoreData] = useState([]);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
    
        if (userDataString) {
          const userData = JSON.parse(userDataString);
          setUserDataSession(userData);
        } else {
          console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {
          Axios.get(
            `${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
          )
            .then((response) => {
                if (response.data) {
                    setStoreData(response.data.ResultData);
                } else {
                    console.error("Error fetching data:", response.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
        }
    }, [userDataSession]);

    useEffect(() => {
        if (storeData.length === 1) {
          const selectedStoreObj = {
            value: storeData[0].StoreId,
            label: storeData[0].Name,
          };
          setSelectedStore(selectedStoreObj);
        }
    }, [storeData]);

    const handleReasonChange = (event) => {
        setReason(event.target.value);
    };

    const handleStoreSelectChange = (selectedOption) => {
        setSelectedStore(selectedOption);
    };

    const handleCancel = () => {
        setReason("");
        setDates([]);
        if (storeData.length === 1) {
          setSelectedStore(storeData[0].StoreId);
        } else {
          setSelectedStore(null);
        }
        const offcanvasElement = document.querySelector('[data-bs-dismiss="offcanvas"]');
        if (offcanvasElement) {
          offcanvasElement.click();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
      
        if (!selectedStore || dates.length === 0) {
            Swal.fire({
                title: "Missing Information",
                text: "Please select a store and choose the start and end dates to proceed.",
                icon: "warning",
            });
            return;
          }
        
          // Check if the start date and end date are the same
          if (dates[0] === dates[1]) {
            Swal.fire({
                title: "Date Error",
                text: "The start and end date/time cannot be the same. Please choose different date/time.",
                icon: "error",
            });
            return;
          }
        
          // Check if the selected store is valid
          if (!selectedStore) {
            Swal.fire({
                title: "Store Not Selected",
                text: "Please select a store to proceed with your request.",
                icon: "error",
            });
            return;
        }

        setLateReqSubLoading(true);
      
        const requestBody = {
          StoreId: selectedStore.value,
          OrgId: userDataSession.OrgId,
          FromDate: dates[0],
          ToDate: dates[1],
          Reason: reason.replace(/['"]/g, ''),
          CreatedBy: userDataSession.UserId,
        };
      console.log(requestBody, 'requestBody')
        Axios.post(`${API_BASE_URL}${INSERT_LATE_INDENT_REQ}`, requestBody)
          .then((response) => {
            console.log(response.data)
            if (response.data.ResultData[0].Status === 'Success') {
              setLateReqSubLoading(false);
              Swal.fire({
                title: `Indent Requested Successfully.`,
                icon: "success",
              }).then((result) => {
                if (result.isConfirmed || result.isDismissed) {
                  setLateReqSubLoading(false);
                  window.location.reload();
                  // handleCancel();
                }
              }); 
            } else {
              setLateReqSubLoading(false);
              Swal.fire({
                title: "Error",
                text: "Failed to Request Submit.",
                icon: "error",
              });
            }
          })
          .catch((error) => {
            setLateReqSubLoading(false);
            console.error('Error:', error);
            Swal.fire({
              title: "Error!",
              text: "An error occurred while submitting the indent request.",
              icon: "error",
            });
          });
      };

    return (
        <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightLateIndentReq"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: '35%', maxWidth: '35%' }}
      >
        <div className="offcanvas-header d-flex align-items-center">
          <h4 id="offcanvasRightLabel" className="me-auto">Request For Late Indent</h4>
          
          <div className="d-flex align-items-center">
            <button
              className="btn btn-primary me-2"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightLateIndentReqView"
              aria-controls="offcanvasRightLateIndentReqView"
              title="View Indent Requests"
            >
              <i className="fa-regular fa-eye fs-5"></i>
            </button>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={handleCancel}
            />
          </div>
        </div>

        <hr />
        <div className="offcanvas-body">
          <form onSubmit={handleSubmit}>
            <div className="row mb-2">
              <div className="col-12 mb-3">
                <label className="form-label">
                  Store<span className="fw-bold text-danger">*</span>
                </label>
                <Select
                  className="select"
                  options={
                    storeData &&
                    storeData?.map((store) => ({
                      value: store.StoreId,
                      label: store.Name,
                    }))
                  }
                  placeholder="Choose store"
                  value={selectedStore || ""}
                  onChange={handleStoreSelectChange}
                />
              </div>
                <div className="col-12">
                    <Space direction="vertical">
                        <Typography.Title level={5}>
                            Date<span className="fw-bold text-danger">*</span>
                        </Typography.Title>
                        <RangePicker
                            showTime={{ format: 'HH:mm' }}
                            format="YYYY-MM-DD HH:mm"
                            value={dates.length ? [moment(dates[0]), moment(dates[1])] : null}
                            onChange={(value, dateString) => {
                                if (value && value.length === 2) {
                                // console.log('Selected Start Time: ', value[0]);
                                // console.log('Selected End Time: ', value[1]);
                                // console.log('Formatted Start Time: ', dateString[0]);
                                // console.log('Formatted End Time: ', dateString[1]);
                                setDates(dateString);
                                }
                            }}
                            style={{ width: '100%' }}
                        />
                    </Space>
                </div>
              <div className="mt-3">
                <label className="form-label">Reason<span className="fw-bold text-danger">*</span></label>
                <textarea
                  className={`form-control `}
                  placeholder="Enter reason for submitting indent outside the allowed days.."
                  rows={6}
                  value={reason}
                  onChange={handleReasonChange} 
                  required
                ></textarea>
              </div>
            </div>

            <div className="modal-footer-btn d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`btn btn-primary me-2`}
              >
                {lateReqSubLoading ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
};

export default ApplyLateIndentReq;